import React from "react";
import cvp from "../../assets/pdf/CV - Mateusz Kaproń.pdf";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();
  return (
    <main className="about-my" id="about">
      <section className="about">
        <h2 className="about-my__hello">{t("about.hello")}</h2>
        <div className="about__description">
          <div className="about__description-left" data-aos="fade-right">
            {t("about.description")} {t("about.experience")}
          </div>
          <div className="about__description-right" data-aos="fade-left">
            <div>{t("about.programing")}</div>
            <div>
              {t("about.info")}
              <a className="cv" href={cvp}>
                <button>{t("about.cv")}</button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
